import React from "react";
import BaseTemplate, { EventContent, LinkButton, MailContent } from "./BaseTemplate";
import styled from "styled-components";

interface MeetingMailProp {
  language: "kr" | "en";
  userName: string;
  eventName: string;
  eventStart: string;
  eventEnd: string;
  date: string;
  rejectDate: string;
  reason: string;
  link: string;
}

export default ({
  language,
  userName,
  eventName,
  eventStart,
  eventEnd,
  date,
  rejectDate,
  reason,
  link,
}: MeetingMailProp) => {
  return (
    <BaseTemplate
      title={language === "en" ? "Participation rejection" : "참가신청 반려 안내"}
      language={language}
    >
      {language === "en" ? (
        <>
          <MailContent>
            Hello, {userName}
            <br />
            The event organizer has been rejected your participation for the following reasons.
          </MailContent>
          <EventContent>
            Event Name:&nbsp; {eventName}
            <br />
            Period:&nbsp;{eventStart}(GMT+9) ~&nbsp;{eventEnd}(GMT+9)
            <br />
            Participating application:&nbsp;{date}(GMT+9)
            <br />
            Organizer's rejection:&nbsp;{rejectDate}
            <br />
          </EventContent>
          <ReasonBox>{reason}</ReasonBox>

          <LinkButton target="_blank" href={link}>
            Go to event{" "}
          </LinkButton>
        </>
      ) : (
        <>
          <MailContent>
            {userName}님 안녕하세요
            <br />
            이벤트 주최자가 회원님의 참가신청을 아래와 같은 이유로 반려하였습니다.
          </MailContent>
          <EventContent>
            이벤트 명:&nbsp; {eventName}
            <br />
            이벤트 기간:
            <br />
            &nbsp;{eventStart}(GMT+9) ~&nbsp;{eventEnd}(GMT+9)
            <br />
            참가신청 일시:&nbsp;{date}(GMT+9)
            <br />
            주최자 반려:&nbsp;{rejectDate}
            <br />
          </EventContent>
          <ReasonBox>{reason}</ReasonBox>
          <LinkButton target="_blank" href={link}>
            이벤트 바로가기
          </LinkButton>
        </>
      )}
    </BaseTemplate>
  );
};

const ReasonBox = styled.div`
  background-color: #f5f5f5;
  padding: 16px 24px;
  margin-bottom: 50px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
`;
